
















import { defineComponent, computed } from '@vue/composition-api'
import moment from 'moment'

import { approvalResults, ILog, workResults, workTargets } from '@/types/log'

type Props = {
  logs: ILog[]
  total: number
  loading: boolean
}

export default defineComponent({
  name: 'LogsTable',
  props: {
    logs: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props) {
    const headers = [
      { text: '更新者ID', value: 'workedById' },
      { text: 'キャストCD', value: 'castId' },
      { text: 'キャスト名', value: 'castName' },
      { text: '更新者分類', value: 'workerType' },
      { text: 'レシートID', value: 'receiptId' },
      { text: '作業日時', value: 'workedAt' },
      { text: '作業時間（秒）', value: 'workDuration' },
      { text: '作業項目', value: 'workTarget' },
      { text: '修正有無', value: 'isModified' },
      { text: '判定', value: 'workResult' },
      { text: '承認結果', value: 'approvalResult' },
      { text: '件数', value: 'count' },
      { text: '基本情報修正有無', value: 'isBasicInfoModified' },
      { text: '商品連携数', value: 'linkedItems' },
      { text: '報酬対象フラグ', value: 'isRewarded' },
      { text: '備考', value: 'note' },
    ]
    const items = computed(() =>
      props.logs.map(log => {
        return {
          ...log,
          workedAt: moment(log.workedAt).format('YYYY/MM/DD HH:mm'),
          workTarget: workTargets.find(w => w.value === log.workTarget)?.text,
          workResult: workResults.find(w => w.value === log.workResult)?.text,
          approvalResult: approvalResults.find(
            a => a.value === log.approvalResult,
          )?.text,
        }
      }),
    )

    return { headers, items }
  },
})
